"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.NEUTRAL100,
      padding: 0,
      '&:hover': {
        color: theme.palette.NEUTRAL300,
        backgroundColor: 'transparent !important',
        // remove yellow circle
        transition: 'all 0.2s ease'
      },
      '&::before': {
        content: "''",
        width: 20,
        height: 20,
        border: "2px solid ".concat(theme.palette.BLUE400),
        borderRadius: 4,
        position: 'absolute',
        opacity: 0,
        transition: 'all 0.2s ease',
        boxSizing: 'content-box'
      },
      '&.Mui-focusVisible': {
        '&::before': {
          opacity: 1,
          transition: 'all 0.2s ease'
        }
      }
    },
    checked: {
      '& > span': {
        color: theme.palette.BLUE400,
        transition: 'all 0.2s ease'
      },
      '&:hover > span': {
        color: theme.palette.BLUE500,
        transition: 'all 0.2s ease'
      }
    },
    disabled: {
      '& > span': {
        color: theme.palette.NEUTRAL050
      },
      '&$checked > span, &$indeterminate > span': {
        color: theme.palette.BLUE075
      }
    },
    indeterminate: {
      '& > span': {
        color: theme.palette.BLUE400,
        transition: 'all 0.2s ease'
      },
      '&:hover > span': {
        color: theme.palette.BLUE500,
        transition: 'all 0.2s ease'
      }
    },
    labelRoot: {
      marginLeft: theme.spacing(0),
      '&::focus-within': {
        outline: 'none'
      }
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL800,
      marginLeft: theme.spacing(1),
      '&.Mui-disabled': {
        color: theme.palette.NEUTRAL100
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;